import { createRouter, createWebHistory } from 'vue-router';
import { authService } from '@/services';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { guest: true }
  },
  {
    path: '/',
    component: () => import('@/layouts/DashboardLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/DashboardView.vue')
      },
      {
        path: 'employment/employers',
        name: 'Employers',
        component: () => import('@/views/EmployersView.vue')
      },
      {
        path: 'employment/work-log',
        name: 'WorkLog',
        component: () => import('@/views/WorkLogView.vue')
      },
      {
        path: 'employment/review',
        name: 'Review',
        component: () => import('@/views/ReviewView.vue')
      },
      {
        path: 'swot',
        name: 'Swot',
        component: () => import('@/views/SwotView.vue')
      },
      {
        path: 'pdp',
        name: 'Pdp',
        component: () => import('@/views/PdpView.vue')
      },
      {
        path: 'forms',
        name: 'Forms',
        component: () => import('@/views/FormsView.vue')
      },
      {
        path: 'feedback',
        name: 'Feedback',
        component: () => import('@/views/FeedbackView.vue')
      }
    ]
  },
  {
    path: '/public/review/:token',
    name: 'PublicReview',
    component: () => import('@/views/PublicReviewView.vue'),
    meta: { public: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = authService.isAuthenticated();

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'Login', query: { redirect: to.fullPath } });
  } else if (to.meta.guest && isAuthenticated) {
    next({ path: '/' });
  } else {
    next();
  }
});

export default router;
